import React, { RefObject } from 'react';
import NoPainIcon from 'assets/svg/NoPainIcon';
import MildIcon from 'assets/svg/MildIcon';
import ModerateIcon from 'assets/svg/ModerateIcon';
import SevereIcon from 'assets/svg/SevereIcon';
import HurtsWorstIcon from 'assets/svg/HurtsWorstIcon';
import clsx from 'clsx';
import styles from 'components/nonPodiatry/page.module.scss';

const ListPainRate = [
  {
    rate: '0',
    name: 'None',
    icon: NoPainIcon,
  },
  {
    rate: '1-3',
    name: 'Mild',
    icon: MildIcon,
  },
  {
    rate: '4-6',
    name: 'Moderate',
    icon: ModerateIcon,
  },
  {
    rate: '7-9',
    name: 'Severe',
    icon: SevereIcon,
  },
  {
    rate: '10',
    name: 'Hurts Worst',
    icon: HurtsWorstIcon,
  },
];

type Props = {
    errorRef?: RefObject<HTMLDivElement>;
    value: string;
    onChange: (value: string) => void;
    hasError?: boolean;
  };

export default function PainRate({
  errorRef,
  onChange,
  value,
  hasError,
}: Props) {
  return (
    <>
      <p>Please rate your pain on a scale from 1 - 10</p>
      {hasError && (
        <p className="error-message">
          Please select at least one range of pain rates.
        </p>
      )}

      <div ref={errorRef} className={styles.painRate}>
        {ListPainRate.map((item, index) => (
          <div
            role="button"
            className={clsx(styles.item, { [styles.itemActive]: value === item.rate })}
            onClick={() => onChange(item.rate)}
            tabIndex={index}
            onKeyDown={() => {}}
            key={item.rate}
          >
            <item.icon />
            <p>{item.name}</p>
            <p className={styles.painRateValue}>{item.rate}</p>
          </div>
        ))}
      </div>
    </>
  );
}
